export class IFilterNewsEvents{
    keyWord: string = "";
    category: number = 0;
    date: string ="";
}